/* eslint-disable no-undef */
import React, { useState, useCallback, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import { sizes } from 'src/styles/Media.styled';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import LogoutPopUp from '../../../common/components/userPanel/LogoutPopUp';
import {
    NavLinkStyle,
    NavLinksBottomContainer,
    NavLinksTopContainer,
    MenuIconContainer,
    MenuIconImage,
    MenuIconActiveImage,
    MoreNavLinksContainter,
    ImgTextCont,
    NavText,
    NavlinksWrapper,
} from './NavLinks.styled';
import Alerts from 'src/assets/images/Menu/Alerts.svg';
import AlertsInactive from 'src/assets/images/Menu/Alerts_Inactive.svg';
import CalendarInactive from 'src/assets/images/Menu/Calendar_Inactive.svg';
import Calendar from 'src/assets/images/Menu/Calendar.svg';
import InventoryInactive from 'src/assets/images/Menu/Inventory_Inactive.svg';
import Inventory from 'src/assets/images/Menu/Inventory.svg';
import OrdersInactive from 'src/assets/images/Menu/Orders_Inactive.svg';
import AdminIconInactive from 'src/assets/images/Admin Black icon.svg';
import AdminIconActive from 'src/assets/images/Admin Blue icon.svg';
import Orders from 'src/assets/images/Menu/Orders.svg';
import Logout from 'src/assets/images/Menu/logout.svg';
import More from 'src/assets/images/Menu/more.svg';
import MoreBlue from 'src/assets/images/Menu/MoreBlue.svg';
import DeniedOverridesActive from 'src/assets/images/Menu/Denied_Overrides_Active.svg';
import DeniedOverridesInActive from 'src/assets/images/Menu/Denied_Overrides_Inactive.svg';
import ProductGuideActive from 'src/assets/images/Menu/Product_Guide_Active.svg';
import ProductGuideInActive from 'src/assets/images/Menu/Product_Guide_Inactive.svg';
import MoreNavLinks from './MoreNavLinks';
import { useHistory } from 'react-router-dom';
import {
    setScheduleSurgeryUnsavedChangesPopUp,
    setRoutePathForSSUnsavedChangesPopUp,
} from 'src/pages/scheduleSurgery/redux/actions';
import {
    setRoutePathForAccountUnsavedChangesPopUp,
    setAccountUnsavedChangesPopUp,
    setRoutePathForAnnouncementUnsavedChangesPopUp,
    setAnnouncementUnsavedChangesPopUp,
    setRoutePathForLinksUnsavedChangesPopUp,
    setLinksUnsavedChangesPopUp,
    setRoutePathForPhysiciansUnsavedChangesPopUp,
    setPhysiciansUnsavedChangesPopUp,
    setRoutePathForProxiesUnsavedChangesPopUp,
    setProxiesUnsavedChangesPopUp,
    setRoutePathForTemplatesUnsavedChangesPopUp,
    setTemplatesUnsavedChangesPopUp,
    setRoutePathForProductGuideUnsavedChangesPopUp,
    setProductGuideUnsavedChangesPopUp,
} from 'src/pages/more/redux/actions';
import {
    navLinkSelectHandler,
    navigateWithBusinessLogic,
    isMobileDevice,
    checkImpersonationActive,
    checkProxyActive,
    forbiddenErrorCheck,
    displayDeniedOverride,
    getUserDetails,
    prevStartDate, 
    prevEndDate
} from 'src/utils/util';
import {
    setEquityUnsavedChangesPopUp,
    setRoutePathForEquityUnsavedChangesPopUp,
} from 'src/pages/equity/redux/actions';
import {
    setConsignmentUnsavedChangesPopUp,
    setRoutePathForConsignmentUnsavedChangesPopUp,
} from 'src/pages/consignmentBilling/redux/actions';
import { sideNavLinksWCMSLinks } from 'src/constants/wcmsRedirectionLinks';
import LogoutActions from 'src/common/components/logoutActions';
import { useTranslation } from 'react-i18next';
import { setShowUnsavedReportUsageChangesPopUp } from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    CC_USER_ROLE,
    ITA_USER_ROLE,
    FIM_USER_ROLE,
    FIA_USER_ROLE,
    INVENTORY,
    SR_USER_ROLE,
    DCA_USER_ROLE,
} from 'src/constants/appConstants';
import {
    resetReceiveSetsListDataReducer,
    setReceiveSetUnsavedChangesPopup,
    setRoutePathForReceiveSetUnsavedChangesPopUp,
} from 'src/pages/receiveSets/redux/actions';
import { useMsal } from '@azure/msal-react';
import { logout as logoutAPI } from 'src/common/redux/actions';
import {
    setConsignmentAddUnsavedChangesPopUp,
    setRoutePathForConsignmentAddUnsavedChangesPopUp,
} from 'src/pages/consignmentAdd/redux/actions';
import { clearProductsGuideData } from 'src/pages/more/pages/productGuide/redux/action';
import {
    setCategoryFilter,
    setDeniedOverrideClicked,
    setLegacyMobileFilterDropdownAction,
    setQuickFilter,
    resetOrderListFilter,
    actionResetOrderList,
    resetAppliedOrderListFilter
} from 'src/pages/orders/redux/actions';
import {
    CategoryLists,
    CategoryListsWithDeniedOverride,
    QuickFilterLabels,
} from 'src/constants/orderListConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const NavLinks = ({ clicked }) => {
    const { instance } = useMsal();
    const { t } = useTranslation();
    const isSelected = useSelector((state) => state.navLinkReducer);
    const surgeryCUInProgress = useSelector(
        (state) => state.surgeryReducer.surgeryCUInProgress
    );
    const equityCUInProgress = useSelector(
        (state) => state.equityReducer.equityCUInProgress
    );
    const consignmentCUInProgress = useSelector(
        (state) => state.consignmentReducer.consignmentCUInProgress
    );
    const consignmentAddCUInProgress = useSelector(
        (state) => state.consignmentAddReducer.consignmentAddCUInProgress
    );
    const settingUpdateInProgress = useSelector(
        (state) => state.getSettingsReducer.settingUpdateInProgress
    );
    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails,
        shallowEqual
    );
    const receiveSetsCUInProgress = useSelector(
        (state) => state.receiveSetsListDataReducer.receiveSetsCUInProgress
    );
    const employeeRole = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.employeeRole
    );
    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );
    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );
    const totalDeniedOrder = useSelector(
        (state) => state.ordersListReducer.totalDeniedOrder
    );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );
    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );
    const isCancelUsageSubmitted = useSelector(
        (state) => state.noUsageToReportReducer?.cancelUsageResponse?.statusCode
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { alerts: alertsMainMenuVisibility, deniedUsageOverrides, calendar: calendarMainMenuVisibility, orders: ordersMainMenuVisibility, productGuide: productGuideMainMenuVisibility, inventory: inventoryMainMenuVisibility, more: moreMainMenuVisibility, admin: adminMainMenuVisibility } =
        useSelector((state) => state.loginReducer.mainMenuVisibility);
    const isInReportUsageSubmitScreen =
        isSubmitClicked ||
        orderStatus?.status ||
        (usageOrderSubmission &&
            (usageOrderSubmission.statusCode ||
                usageOrderSubmission.errorCode) &&
            usageOrderSubmission.clickedBtn === 'submit');

    const createReceiveSets = useSelector(
        (state) => state.createReceiveSetsReducer?.createReceiveSets
    );
    const isInReceiveSetSubmitScreen =
        createReceiveSets && createReceiveSets?.myCaseRef;

    const userRole = getUserDetails();
    const {
        appliedCategory
    } = useSelector((state) => state.orderFilterReducer);

    const dispatch = useDispatch();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [logoutPopUp, setlogoutPopUp] = useState(false);
    const [isExpand, setExpand] = useState(false);
    const [touchStartY, setTouchStartY] = useState(null);
    const [touchMoved, setTouchMoved] = useState(false);
    const [touchStartX, setTouchStartX] = useState(null);
 
    const [, setCategoryList] = useState(
        displayDeniedOverride(
            checkImpersonationActive() || checkProxyActive()
                ? sessionStorage.getItem('ProxyUserRole')
                : employeeRole,
            countryISOCode
        )
            ? CategoryListsWithDeniedOverride()
            : CategoryLists()
    );
    const [logoutRquested, setLogoutRquested] = useState(false);
    const pageName = useSelector(
        (state) => state.commonTemplateReducer.pageName
    );
    const routePathForTemplatesUnsavedChangesPopUp = useSelector(
        (state) =>
            state.templatesReducer.routePathForTemplatesUnsavedChangesPopUp
    );
    const subCategoryRefineData = useSelector(
        (state) =>
            state.productsGuideReducer.productGuideData.subCategoryRefineData
    );
    const selectedBrands = useSelector(
        (state) => state.productsGuideReducer.selectedBrands
    );
    const products = useSelector(
        (state) => state.searchProductsReducer.products
    );
    // const defaultView = useSelector(
    //     (state) => state.getSettingsReducer.calendarSettings.defaultView
    // );
    // const isCalendarSharing = useSelector(
    //     (state) => state.getSettingsReducer.calendarSettings.isCalendarSharing
    // );
    // const notificationSettings = useSelector(
    //     (state) => state.getSettingsReducer.notificationSettings
    // );
    // let value = defaultView!='list' ||
    // let path = routePathForTemplatesUnsavedChangesPopUp.path;
    const settingsValue = useSelector(
        (state) => state.getSettingsReducer.settingsValue
    );

    // const isForbidden = useSelector(
    //     (state) => state.loginReducer.isForbidden
    // );

    const productGuideValue = useSelector(
        (state) => state.ProductsGuideReducer.productGuideValue
    );
    const isDestructiveEnabled = useSelector(
        (state) => state.loginReducer.isDestructiveEnabled
    );
    const open = Boolean(anchorEl);
    const isDestructive =
        isDestructiveEnabled ||
        (bannerInfo &&
            !checkProxyActive() &&
            !checkImpersonationActive() &&
            bannerInfo.filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0);

    const handleClose = () => {
        setAnchorEl(null);
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar: false,
                admin: false,
                orders: false,
                alerts: false,
                inventory: false,
                more: true,
                deniedUsageOverrides: false,
                productGuide: false,
            })
        );
    };
    const onShowMoreOverLay = (event) => { 
        setAnchorEl(event.currentTarget);
    };

    const logout = () => {
        setLogoutRquested(true);
        clicked();
        setMoreOption('');
    };

    const onLogout = () => {
        setlogoutPopUp(true);
    };

    const onClose = () => {
        setlogoutPopUp(false);
    };

    const handleMenuTouchStart = (e) => {
        if (e.touches && e.touches.length === 1) {
            setTouchStartY(e.touches[0].clientY);
            setTouchStartX(e.touches[0].clientX);
            setTouchMoved(false);
        }
    };

    const handleMenuTouchMove = (e) => {
        if (touchStartY !== null && touchStartX !== null && e.touches && e.touches.length === 1) {
            const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
            const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
            if (deltaY > 10 || deltaX > 10) setTouchMoved(true);
        }
    };

    const handleMenuTouchEnd = (e, action) => {
        if (!touchMoved && action) action();
        setTouchStartY(null);
        setTouchStartX(null);
        setTouchMoved(false);
    };

    // const handleTouchStart = useCallback((event, action) => {
    //     if (event.currentTarget) {
    //         event.preventDefault();
    //         event.currentTarget.setAttribute('data-touch-handled', 'true');
    //         action();
    //     }
    // }, []);



    const handleClick = useCallback((event, action) => {
        event.stopPropagation(); 
        const touchHandled =
            event.currentTarget?.getAttribute('data-touch-handled');
        if (touchHandled === 'true') {
            event.currentTarget.removeAttribute('data-touch-handled');
            return;
        }
        if (!event.defaultPrevented && action) {
            action();
        }
    }, []);

    const touchOptimizedStyle = useMemo(
        () => ({
            touchAction: 'manipulation',
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
        }),
        []
    );

    const navigateWithBusinessLogicLocal = (event, path, selectOption) => {
        navigateWithBusinessLogic(
            setDeniedOverrideClicked,
            event,
            path,
            selectOption,
            surgeryCUInProgress,
            settingUpdateInProgress,
            dispatch,
            setRoutePathForSSUnsavedChangesPopUp,
            setScheduleSurgeryUnsavedChangesPopUp,
            history,
            navLinkSelectHandler,
            setActiveNavLink,
            clicked,
            setShowUnsavedReportUsageChangesPopUp,
            isInReportUsageSubmitScreen,
            isCancelUsageSubmitted,
            equityCUInProgress,
            setRoutePathForEquityUnsavedChangesPopUp,
            setEquityUnsavedChangesPopUp,
            consignmentCUInProgress,
            setRoutePathForConsignmentUnsavedChangesPopUp,
            setConsignmentUnsavedChangesPopUp,
            setRoutePathForAnnouncementUnsavedChangesPopUp,
            setAnnouncementUnsavedChangesPopUp,
            setAccountUnsavedChangesPopUp,
            setRoutePathForAccountUnsavedChangesPopUp,
            setLinksUnsavedChangesPopUp,
            setRoutePathForLinksUnsavedChangesPopUp,
            setPhysiciansUnsavedChangesPopUp,
            setRoutePathForPhysiciansUnsavedChangesPopUp,
            setProxiesUnsavedChangesPopUp,
            setRoutePathForProxiesUnsavedChangesPopUp,
            pageName,
            routePathForTemplatesUnsavedChangesPopUp,
            setTemplatesUnsavedChangesPopUp,
            setRoutePathForTemplatesUnsavedChangesPopUp,
            setProductGuideUnsavedChangesPopUp,
            setRoutePathForProductGuideUnsavedChangesPopUp,
            products,
            selectedBrands,
            subCategoryRefineData,
            settingsValue,
            productGuideValue,
            // defaultView,
            // isCalendarSharing,
            // notificationSettings
            setReceiveSetUnsavedChangesPopup,
            setRoutePathForReceiveSetUnsavedChangesPopUp,
            receiveSetsCUInProgress,
            isInReceiveSetSubmitScreen,
            consignmentAddCUInProgress,
            setConsignmentAddUnsavedChangesPopUp,
            setRoutePathForConsignmentAddUnsavedChangesPopUp
        );
        sessionStorage.setItem('isRedirectToWCMS', true);
    };
    const [selectedMoreOption, setMoreOption] = useState('');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffectWithErrorLogging(() => {
        setCategoryList(
            displayDeniedOverride(
                checkImpersonationActive() || checkProxyActive()
                    ? sessionStorage.getItem('ProxyUserRole')
                    : employeeRole,
                countryISOCode
            )
                ? CategoryListsWithDeniedOverride()
                : CategoryLists()
        );
    }, [userDetails]);

    const moreOptionLabel = (name) => {
        setMoreOption(name);
    };
    let isMobile = isMobileDevice();
    // useEffectWithErrorLogging(()=>{
    //     setIsForbidden(true);
    // },[]);
    // useEffectWithErrorLogging(()=>{
    //     forbiddenErrorCheck(instance, dispatch, logoutAPI) ? setIsForbidden(false) : setIsForbidden(true);
    // }, [isForbidden]);
    return (
        <>
            <LogoutActions
                logoutRquested={logoutRquested}
                setlogoutPopUp={setlogoutPopUp}
            />
            <NavlinksWrapper>
                {!isDestructive && !forbiddenErrorCheck() && (
                    <NavLinksTopContainer className="nav-links">
                        {((employeeRole &&
                            (employeeRole === CC_USER_ROLE ||
                                employeeRole === ITA_USER_ROLE) &&
                            // ||
                            // employeeRole === FIM_USER_ROLE
                            !checkImpersonationActive() &&
                            !checkProxyActive()) ||
                            ((checkImpersonationActive() ||
                                checkProxyActive()) &&
                                (sessionStorage.getItem('ProxyUserRole') ===
                                    CC_USER_ROLE ||
                                    sessionStorage.getItem('ProxyUserRole') ===
                                    ITA_USER_ROLE))) && adminMainMenuVisibility && (
                                //     ||
                                // sessionStorage.getItem('ProxyUserRole') ===
                                //     FIM_USER_ROLE
                                <NavLinkStyle style={touchOptimizedStyle}>
                                    <NavLink
                                        to="/"
                                        onTouchStart={handleMenuTouchStart}
                                        onTouchMove={handleMenuTouchMove}
                                        onTouchEnd={(e) =>
                                            handleMenuTouchEnd(e, () => {
                                                navigateWithBusinessLogicLocal(
                                                    e,
                                                    '/',
                                                    'admin'
                                                );
                                                setMoreOption('');
                                            })
                                        }
                                        onClick={(e) =>
                                            handleClick(e, () => {
                                                navigateWithBusinessLogicLocal(
                                                    e,
                                                    '/',
                                                    'admin'
                                                );
                                                setMoreOption('');
                                            })
                                        }
                                    >
                                        <ImgTextCont
                                            leftBorder={isSelected.admin}
                                            fontSize={
                                                window.innerWidth >
                                                sizes.smalDevice && '1.775rem'
                                            }
                                        >
                                            <MenuIconContainer>
                                                {!isSelected.admin && (
                                                    <MenuIconImage
                                                        defaultImg={
                                                            AdminIconInactive
                                                        }
                                                        name="Admin"
                                                    />
                                                )}
                                                {isSelected.admin && (
                                                    <MenuIconActiveImage
                                                        activeImg={AdminIconActive}
                                                        name="Admin"
                                                    />
                                                )}
                                            </MenuIconContainer>
                                            <NavText selected={isSelected.admin}>
                                                {t('common.admin')}
                                            </NavText>
                                        </ImgTextCont>
                                    </NavLink>
                                </NavLinkStyle>
                            )}
                        {((employeeRole &&
                            employeeRole === FIM_USER_ROLE &&
                            !checkImpersonationActive() &&
                            !checkProxyActive()) ||
                            ((checkImpersonationActive() ||
                                checkProxyActive()) &&
                                sessionStorage.getItem('ProxyUserRole') ===
                                FIM_USER_ROLE)) && adminMainMenuVisibility && (
                                //     ||
                                // sessionStorage.getItem('ProxyUserRole') ===
                                //     FIM_USER_ROLE
                                <NavLinkStyle style={touchOptimizedStyle}>
                                    <NavLink
                                        to="/adminView"
                                        onTouchStart={handleMenuTouchStart}
                                        onTouchMove={handleMenuTouchMove}
                                        onTouchEnd={(e) =>
                                            handleMenuTouchEnd(e, () => {
                                                navigateWithBusinessLogicLocal(
                                                    e,
                                                    '/adminView',
                                                    'admin'
                                                );
                                                setMoreOption('');
                                            })
                                        }
                                        onClick={(e) =>
                                            handleClick(e, () => {
                                                navigateWithBusinessLogicLocal(
                                                    e,
                                                    '/adminView',
                                                    'admin'
                                                );
                                                setMoreOption('');
                                            })
                                        }
                                    >
                                        <ImgTextCont
                                            leftBorder={isSelected.admin}
                                            fontSize={
                                                window.innerWidth >
                                                sizes.smalDevice && '1.775rem'
                                            }
                                        >
                                            <MenuIconContainer>
                                                {!isSelected.admin && (
                                                    <MenuIconImage
                                                        defaultImg={
                                                            AdminIconInactive
                                                        }
                                                        name="Admin"
                                                    />
                                                )}
                                                {isSelected.admin && (
                                                    <MenuIconActiveImage
                                                        activeImg={AdminIconActive}
                                                        name="Admin"
                                                    />
                                                )}
                                            </MenuIconContainer>
                                            <NavText selected={isSelected.admin}>
                                                {t('common.admin')}
                                            </NavText>
                                        </ImgTextCont>
                                    </NavLink>
                                </NavLinkStyle>
                            )}
                        {calendarMainMenuVisibility && (
                            <NavLinkStyle style={touchOptimizedStyle}>
                                <NavLink
                                    to={
                                        userRole === FIM_USER_ROLE ||
                                            userRole === FIA_USER_ROLE
                                            ? '/home'
                                            : '/'
                                    }
                                    onTouchStart={handleMenuTouchStart}
                                    onTouchMove={handleMenuTouchMove}
                                    onTouchEnd={(e) =>
                                        handleMenuTouchEnd(e, () => {
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                userRole === FIM_USER_ROLE ||
                                                    userRole === FIA_USER_ROLE
                                                    ? '/home'
                                                    : '/',
                                                'calendar'
                                            );
                                            setMoreOption('');
                                            prevStartDate.current = null;
                                            prevEndDate.current = null;
                                        })
                                    }
                                    onClick={(e) =>
                                        handleClick(e, () => {
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                userRole === FIM_USER_ROLE ||
                                                    userRole === FIA_USER_ROLE
                                                    ? '/home'
                                                    : '/',
                                                'calendar'
                                            );
                                            setMoreOption('');
                                        })
                                    }
                                >
                                    <ImgTextCont
                                        leftBorder={isSelected.calendar}
                                    >
                                        <MenuIconContainer>
                                            {!isSelected.calendar && (
                                                <MenuIconImage
                                                    defaultImg={
                                                        CalendarInactive
                                                    }
                                                    name="Calendar"
                                                />
                                            )}
                                            {isSelected.calendar && (
                                                <MenuIconActiveImage
                                                    activeImg={Calendar}
                                                    name="calendar"
                                                />
                                            )}
                                        </MenuIconContainer>
                                        <NavText selected={isSelected.calendar}>
                                            {t('common.calendarLabel')}
                                        </NavText>
                                    </ImgTextCont>
                                </NavLink>
                            </NavLinkStyle>
                        )}

                        {ordersMainMenuVisibility && (
                            <NavLinkStyle
                                style={{
                                    ...touchOptimizedStyle,
                                }}
                            >
                                <NavLink
                                    to="/orders"
                                    onTouchStart={handleMenuTouchStart}
                                    onTouchMove={handleMenuTouchMove}
                                    onTouchEnd={(e) =>
                                        handleMenuTouchEnd(e, () => {
                                            const wasOnOrders =
                                                history.location.pathname ===
                                                '/orders';
                                            dispatch(
                                                setLegacyMobileFilterDropdownAction()
                                            );  
                                            dispatch(actionResetOrderList());
                                            if (wasOnOrders) {
                                                dispatch(resetOrderListFilter());
                                            }
                                            dispatch(resetAppliedOrderListFilter());
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                process.env.ENABLE_ORDERS
                                                    ? '/orders'
                                                    : sideNavLinksWCMSLinks(
                                                        'orders'
                                                    ),
                                                'orders'
                                            );
                                            setMoreOption('');
                                            if (
                                                process.env.ENABLE_ORDERS &&
                                                wasOnOrders
                                            ) {
                                                history.push('/orders');
                                            }
                                        })
                                    }
                                    onClick={(e) =>
                                        handleClick(e, () => {
                                            const wasOnOrders =
                                                history.location.pathname ===
                                                '/orders';
                                            dispatch(
                                                setLegacyMobileFilterDropdownAction()
                                            );
                                            dispatch(actionResetOrderList());
                                            dispatch(resetAppliedOrderListFilter());
                                            if (wasOnOrders) {
                                                dispatch(resetOrderListFilter());
                                            }
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                process.env.ENABLE_ORDERS
                                                    ? '/orders'
                                                    : sideNavLinksWCMSLinks(
                                                        'orders'
                                                    ),
                                                'orders'
                                            );
                                            setMoreOption('');
                                            if (
                                                process.env.ENABLE_ORDERS &&
                                                wasOnOrders
                                            ) {
                                                history.push('/orders');
                                            }
                                        })
                                    }
                                >
                                    <ImgTextCont leftBorder={isSelected.orders}>
                                        <MenuIconContainer>
                                            {!isSelected.orders && (
                                                <MenuIconImage
                                                    defaultImg={OrdersInactive}
                                                    name="Orders"
                                                />
                                            )}
                                            {isSelected.orders && (
                                                <MenuIconActiveImage
                                                    activeImg={Orders}
                                                    name="Orders"
                                                />
                                            )}
                                        </MenuIconContainer>
                                        <NavText selected={isSelected.orders}>
                                            {t('navLink.ordersLabel')}
                                        </NavText>
                                    </ImgTextCont>
                                </NavLink>
                            </NavLinkStyle>)}
                        {deniedUsageOverrides &&
                            displayDeniedOverride(
                                checkImpersonationActive() || checkProxyActive()
                                    ? sessionStorage.getItem('ProxyUserRole')
                                    : employeeRole,
                                countryISOCode
                            ) && (
                                <NavLinkStyle>
                                    <NavLink
                                        to="/orders"
                                        onClick={(e) => {
                                            dispatch(
                                                setLegacyMobileFilterDropdownAction()
                                            );
                                            document
                                                .getElementById(
                                                    'ordersContainer'
                                                )
                                                ?.scrollTo(0, 0);
                                            document
                                                .getElementById('ordersPage')
                                                ?.scrollTo(0, 0);
                                            document
                                                .getElementById(
                                                    'ordersPageContainer'
                                                )
                                                ?.scrollTo(0, 0);
                                            document
                                                .getElementById(
                                                    'filterContainer'
                                                )
                                                ?.scrollTo(0, 0);
                                            displayDeniedOverride(
                                                checkImpersonationActive() ||
                                                    checkProxyActive()
                                                    ? sessionStorage.getItem(
                                                        'ProxyUserRole'
                                                    )
                                                    : employeeRole,
                                                countryISOCode
                                            )
                                                ? dispatch(
                                                    setCategoryFilter({
                                                        ...CategoryListsWithDeniedOverride()[2],
                                                    })
                                                )
                                                : dispatch(
                                                    setCategoryFilter({
                                                        ...CategoryLists()[2],
                                                    })
                                                );
                                            let quickFilter = QuickFilterLabels(
                                                t(
                                                    'orders.orderQuickFilters.deniedUsageOverrides.name'
                                                )
                                            );
                                            dispatch(
                                                setQuickFilter({
                                                    ...quickFilter[0],
                                                    statusCode: '',
                                                })
                                            );
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                process.env.ENABLE_ORDERS
                                                    ? '/orders'
                                                    : sideNavLinksWCMSLinks(
                                                        'orders'
                                                    ),
                                                'deniedUsageOverrides'
                                            );
                                            setMoreOption('');
                                        }}
                                    >
                                        <ImgTextCont
                                            leftBorder={
                                                isSelected.deniedUsageOverrides
                                            }
                                        >
                                            <MenuIconContainer>
                                                {!isSelected.deniedUsageOverrides && (
                                                    <div
                                                        style={{
                                                            position:
                                                                'relative',
                                                            display:
                                                                'inline-block',
                                                        }}
                                                    >
                                                        <MenuIconImage
                                                            defaultImg={
                                                                DeniedOverridesInActive
                                                            }
                                                            name="Denied Usage Overrides"
                                                            style={{
                                                                padding: '4px',
                                                                height: '32px',
                                                            }}
                                                        />
                                                        {totalDeniedOrder >
                                                            0 && (
                                                                <div
                                                                    style={{
                                                                        position:
                                                                            'absolute',
                                                                        top: '50%',
                                                                        left: '50%',
                                                                        transform:
                                                                            'translate(7%, -145%)',
                                                                        backgroundColor:
                                                                            '#12C8F7',
                                                                        color: '#140f4b',
                                                                        borderRadius:
                                                                            '50%',
                                                                        border: '1px solid #140f4b',
                                                                        fontSize:
                                                                            '10px',
                                                                        height: '17px',
                                                                        width: '17px',
                                                                        fontWeight:
                                                                            'bold',
                                                                    }}
                                                                >
                                                                    {
                                                                        totalDeniedOrder
                                                                    }
                                                                </div>
                                                            )}
                                                    </div>
                                                )}
                                                {isSelected.deniedUsageOverrides && (
                                                    <div
                                                        style={{
                                                            position:
                                                                'relative',
                                                            display:
                                                                'inline-block',
                                                        }}
                                                    >
                                                        <MenuIconActiveImage
                                                            activeImg={
                                                                DeniedOverridesActive
                                                            }
                                                            name="Denied Usage Overrides"
                                                            style={{
                                                                padding: '4px',
                                                                height: '32px',
                                                            }}
                                                        />
                                                        {totalDeniedOrder >
                                                            0 && (
                                                                <div
                                                                    style={{
                                                                        position:
                                                                            'absolute',
                                                                        top: '50%',
                                                                        left: '50%',
                                                                        transform:
                                                                            'translate(7%, -145%)',
                                                                        backgroundColor:
                                                                            '#12C8F7',
                                                                        color: '#140f4b',
                                                                        borderRadius:
                                                                            '50%',
                                                                        border: '1px solid #140f4b',
                                                                        fontSize:
                                                                            '10px',
                                                                        height: '17px',
                                                                        width: '17px',
                                                                        fontWeight:
                                                                            'bold',
                                                                    }}
                                                                >
                                                                    {
                                                                        totalDeniedOrder
                                                                    }
                                                                </div>
                                                            )}
                                                    </div>
                                                )}
                                            </MenuIconContainer>
                                            <NavText
                                                selected={
                                                    isSelected.deniedUsageOverrides
                                                }
                                            >
                                                {t(
                                                    'navLink.deniedUsageOverridesLabel'
                                                )}
                                            </NavText>
                                        </ImgTextCont>
                                    </NavLink>
                                </NavLinkStyle>
                            )}
                        {alertsMainMenuVisibility && (
                            <NavLinkStyle style={touchOptimizedStyle}>
                                <NavLink
                                    to="/"
                                    onTouchStart={handleMenuTouchStart}
                                    onTouchMove={handleMenuTouchMove}
                                    onTouchEnd={(e) =>
                                        handleMenuTouchEnd(e, () => {
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                sideNavLinksWCMSLinks('alerts'),
                                                'alerts'
                                            );
                                            setMoreOption('');
                                        })
                                    }
                                    onClick={(e) =>
                                        handleClick(e, () => {
                                            navigateWithBusinessLogicLocal(
                                                e,
                                                sideNavLinksWCMSLinks('alerts'),
                                                'alerts'
                                            );
                                            setMoreOption('');
                                        })
                                    }
                                >
                                    <ImgTextCont leftBorder={isSelected.alerts}>
                                        <MenuIconContainer>
                                            {!isSelected.alerts && (
                                                <MenuIconImage
                                                    defaultImg={AlertsInactive}
                                                    name="Alerts"
                                                />
                                            )}
                                            {isSelected.alerts && (
                                                <MenuIconActiveImage
                                                    activeImg={Alerts}
                                                    name="Alerts"
                                                />
                                            )}
                                        </MenuIconContainer>
                                        <NavText selected={isSelected.alerts}>
                                            {t('navLink.alertsLabel')}
                                        </NavText>
                                    </ImgTextCont>
                                </NavLink>
                            </NavLinkStyle>
                        )}
                        {productGuideMainMenuVisibility && <NavLinkStyle style={touchOptimizedStyle}>
                            <NavLink
                                to="/productGuide"
                                onTouchStart={handleMenuTouchStart}
                                onTouchMove={handleMenuTouchMove}
                                onTouchEnd={(e) =>
                                    handleMenuTouchEnd(e, () => {
                                        navigateWithBusinessLogicLocal(
                                            e,
                                            process.env.ENABLE_PRODUCT_GUIDE
                                                ? '/productGuide'
                                                : sideNavLinksWCMSLinks(
                                                    'productGuide'
                                                ),
                                            'productGuide'
                                        );
                                        setMoreOption('');
                                        dispatch(clearProductsGuideData());
                                    })
                                }
                                onClick={(e) =>
                                    handleClick(e, () => {
                                        navigateWithBusinessLogicLocal(
                                            e,
                                            process.env.ENABLE_PRODUCT_GUIDE
                                                ? '/productGuide'
                                                : sideNavLinksWCMSLinks(
                                                    'productGuide'
                                                ),
                                            'productGuide'
                                        );
                                        setMoreOption('');
                                        dispatch(clearProductsGuideData());
                                    })
                                }
                            >
                                <ImgTextCont
                                    leftBorder={isSelected.productGuide}
                                >
                                    <MenuIconContainer>
                                        {!isSelected.productGuide && (
                                            <MenuIconImage
                                                defaultImg={
                                                    ProductGuideInActive
                                                }
                                                name={t(
                                                    'navLink.productGuideLabel'
                                                )}
                                                style={{ padding: '4px' }}
                                            />
                                        )}
                                        {isSelected.productGuide && (
                                            <MenuIconActiveImage
                                                activeImg={ProductGuideActive}
                                                name={t(
                                                    'navLink.productGuideLabel'
                                                )}
                                                style={{ padding: '4px' }}
                                            />
                                        )}
                                    </MenuIconContainer>
                                    <NavText selected={isSelected.productGuide}>
                                        {t('navLink.productGuideLabel')}
                                    </NavText>
                                </ImgTextCont>
                            </NavLink>
                        </NavLinkStyle>}
                        {inventoryMainMenuVisibility && <NavLinkStyle style={touchOptimizedStyle}>
                            <NavLink
                                to="/receiveSets"
                                onTouchStart={handleMenuTouchStart}
                                onTouchMove={handleMenuTouchMove}
                                onTouchEnd={(e) =>
                                    handleMenuTouchEnd(e, () => {
                                        resetReceiveSetsListDataReducer();
                                        navigateWithBusinessLogicLocal(
                                            e,
                                            process.env.ENABLE_RECEIVESETS
                                                ? '/receiveSets'
                                                : sideNavLinksWCMSLinks(
                                                    'inventory'
                                                ),
                                            'inventory'
                                        );
                                        setMoreOption('');
                                    })
                                }
                                onClick={(e) =>
                                    handleClick(e, () => {
                                        resetReceiveSetsListDataReducer();
                                        navigateWithBusinessLogicLocal(
                                            e,
                                            process.env.ENABLE_RECEIVESETS
                                                ? '/receiveSets'
                                                : sideNavLinksWCMSLinks(
                                                    'inventory'
                                                ),
                                            'inventory'
                                        );
                                        setMoreOption('');
                                    })
                                }
                            >
                                <ImgTextCont leftBorder={isSelected.inventory}>
                                    <MenuIconContainer>
                                        {!isSelected.inventory && (
                                            <MenuIconImage
                                                defaultImg={InventoryInactive}
                                                name="Inventory"
                                            />
                                        )}
                                        {isSelected.inventory && (
                                            <MenuIconActiveImage
                                                activeImg={Inventory}
                                                name="Inventory"
                                            />
                                        )}
                                    </MenuIconContainer>
                                    <NavText selected={isSelected.inventory}>
                                        {t('navLink.inventoryLabel')}
                                    </NavText>
                                </ImgTextCont>
                            </NavLink>
                        </NavLinkStyle>}
                       {moreMainMenuVisibility && (
    <NavLinkStyle style={{ cursor: 'pointer', ...touchOptimizedStyle }}>
        <button
            type="button"
            data-testid="nav-more-button"
            aria-label={t('navLink.moreLabel')}
            aria-controls="long-menu"
            aria-haspopup="true"
            style={{
                all: 'unset',
                display: 'block',
                width: '100%',
                cursor: 'pointer'
            }}
            {...(isMobile
                ? {
                    onTouchStart: handleMenuTouchStart,
                    onTouchMove: handleMenuTouchMove,
                    onTouchEnd: (e) => handleMenuTouchEnd(e, () => {
                        setExpand((prev) => !prev);
                        if (window.innerWidth > sizes.portraitDevice && !isMobile) {
                            onShowMoreOverLay(e);
                        }
                    }),
                }
                : {
                    onClick: (e) => {
                        e.preventDefault(); // prevent any accidental navigation
                        e.stopPropagation();
                        setExpand((prev) => !prev);
                        if (window.innerWidth > sizes.portraitDevice && !isMobile) {
                            onShowMoreOverLay(e);
                        }
                    },
                })}
        >
            <ImgTextCont leftBorder={isSelected.more}>
                <MenuIconContainer>
                    {!isSelected.more && (
                        <MenuIconImage defaultImg={More} name="More" />
                    )}
                    {isSelected.more && (
                        <MenuIconActiveImage activeImg={MoreBlue} name="More" />
                    )}
                </MenuIconContainer>
                <div className="moreText" selected={isSelected.more}>
                    <NavText selected={isSelected.more}>
                        {t('navLink.moreLabel')}
                    </NavText>
                </div>
            </ImgTextCont>
        </button>
    </NavLinkStyle>
)}
                    </NavLinksTopContainer>
                )}

                {!isDestructive &&
                    !forbiddenErrorCheck(instance, dispatch, logoutAPI) && (
                        <MoreNavLinksContainter>
                            {isExpand && (
                                <MoreNavLinks
                                    activeLabel={selectedMoreOption}
                                    handleClose={handleClose}
                                    navigateWithBusinessLogic={
                                        navigateWithBusinessLogicLocal
                                    }
                                    selectedOption={moreOptionLabel} />
                            )}
                        </MoreNavLinksContainter>
                    )}
                {!isDestructive && !forbiddenErrorCheck() && (
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={() => {
                            setAnchorEl(null);
                        }}
                        // style={{ left: '65px' }}
                        style={{
                            left: '65px',
                        }}
                        PaperProps={{
                            style: {
                                width: '26ch',
                                maxHeight: bannerHeight ? '320px' : 'auto',
                                overflowY: bannerHeight ? 'scroll' : 'auto',
                                bottom: bannerHeight && '10px',
                            },
                        }}
                    >
                        <MoreNavLinks
                            handleClose={handleClose}
                            selectedOption={moreOptionLabel}
                            navigateWithBusinessLogic={
                                navigateWithBusinessLogicLocal
                            }
                        />
                    </Menu>
                )}
                <NavLinksBottomContainer>
                    <NavLinkStyle
                        style={touchOptimizedStyle}
                        onTouchStart={handleMenuTouchStart}
                        onTouchMove={handleMenuTouchMove}
                        onTouchEnd={(e) => handleMenuTouchEnd(e, onLogout)}
                        onClick={(e) => handleClick(e, onLogout)}
                    >
                        <ImgTextCont>
                            <MenuIconContainer>
                                <MenuIconImage
                                    defaultImg={Logout}
                                    name="logout"
                                />
                            </MenuIconContainer>
                            <NavText> {t('common.logoutButton')}</NavText>
                        </ImgTextCont>
                    </NavLinkStyle>
                </NavLinksBottomContainer>
            </NavlinksWrapper>
            {logoutPopUp && (
                <LogoutPopUp
                    logout={() => logout()}
                    onClose={() => onClose()}
                />
            )}
        </>
    );
};

NavLinks.defaultProps = {
    clicked: () => { },
};

export default NavLinks;
